// import node module libraries
import { Fragment, useEffect, useState } from 'react';
import {
	Breadcrumb,
	Button,
	Card,
	Col,
	Offcanvas,
	Row,
	Tab
} from 'react-bootstrap';

// import custom components
import OffcanvasAddFraisscolariteForm from '../add-new-fraisscolarite/OffcanvasAddFraisscolariteForm';

// import sub components
import FraisscolaritesListItems from './FraisscolaritesListItems';
import FraisscolariteService from '../../services/FraisscolariteService';

const Fraisscolarites = () => {
	const [fraisscolarites, setFraisscolarites] = useState([]);
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	useEffect(() => {
		FraisscolariteService.getAllFraisscolarites().then((response) => {
			setFraisscolarites(response);
		});
	}, []);

	return (
		<Fragment>
			<Tab.Container defaultActiveKey="list">
				<Row>
					<Col lg={12} md={12} sm={12}>
						<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-between">
							<div className="mb-3 mb-md-0">
								<h1 className="mb-1 h2 fw-bold">
									Frais de scolarité
								</h1>
								<Breadcrumb>
									<Breadcrumb.Item href="/">
										Accueil
									</Breadcrumb.Item>
									<Breadcrumb.Item active>Frais de scolarité</Breadcrumb.Item>
								</Breadcrumb>
							</div>
							<div className="d-flex align-items-center justify-content-between">

								<div>
									<Button onClick={handleShow}>Ajouter une scolarité</Button>
									<Offcanvas
										show={show}
										onHide={handleClose}
										placement="end"
										name="end"
										style={{ width: '600px' }}
									>
										<Offcanvas.Header closeButton>
											<Offcanvas.Title as="h3">
												Enregistrer une scolarite
											</Offcanvas.Title>
										</Offcanvas.Header>
										<Offcanvas.Body className="pt-0">
											<OffcanvasAddFraisscolariteForm onClick={handleClose} />
										</Offcanvas.Body>
									</Offcanvas>
								</div>
							</div>
						</div>
					</Col>
				</Row>

				<Tab.Content>

					<Tab.Pane eventKey="list" className="pb-4">
						<Card className="mb-5 ">
							<Card.Body className="p-0">
								{/* Fraisscolarites in list view */}
								<FraisscolaritesListItems />
								{/* end of Fraisscolarites in list view */}
							</Card.Body>
						</Card>
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</Fragment>
	);
};
export default Fraisscolarites;
